'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.faqSearch = twentyninetimes.faqSearch || function () {

	function init() {
		var faqs = document.querySelectorAll('.item-faq'),
			searchInput = document.getElementById('faq-search');

		if ( faqs && searchInput ) {
			faqSearchFunction(searchInput, faqs);
		}
	}

	function faqSearchFunction(searchInput, faqs) {
		var loops = document.querySelectorAll('.loop--faq .loop__inner'),
			errorMessage = document.querySelector('.error-message');

		searchInput.addEventListener("input", (e) => {
			var inputValue = e.target.value,
				valueLength = inputValue.length;

			( !inputValue == '' )
			    ? searchInput.classList.add('has-value')
			    : searchInput.classList.remove('has-value');

			if ( valueLength < 3 && valueLength != 0 ) return;

			faqs.forEach((faq) => {
			  if (
			    faq.innerText
			      .toLowerCase()
			      .includes(inputValue.toLowerCase()) ||
			    !inputValue
			  ) {
			    faq.classList.remove("item-faq--hidden");
			  } else {
			    faq.classList.add("item-faq--hidden");
			  }
			});

			loops.forEach((loop) => {
				var hasFaq = loop.querySelectorAll('.item-faq:not(.item-faq--hidden)');

				if ( hasFaq.length > 0 ) {
					loop.classList.remove('loop__inner--hidden');
				} else {
					loop.classList.add('loop__inner--hidden');
				}
			});

			var hasLoops = document.querySelectorAll('.loop--faq .loop__inner:not(.loop__inner--hidden)');
			if ( hasLoops.length > 0 ) {
				errorMessage.classList.add('error-message--hidden');
			} else {
				errorMessage.classList.remove('error-message--hidden');
			}
		});
	}

	return {
		init : init
	};

}();